import docReady from 'doc-ready'

import {addHandler, windowSize, windowScroll} from '../util/scroll_resize'
import {initContainers, getInitInstance} from '../util/init'
import {updateLinkState} from '../util/link_state'
import {toggle, parallax, relativeScroll, fakeLazyLoad, getOffset, scrollPointTrigger} from '../util/tools'
import {PHONE_MAX} from './constants'

docReady(() => {
  let setup = new SiteSetup()
  let init = new SiteInit()
  window.setTimeout(() => {
    document.body.style.opacity = null
    document.documentElement.classList.add('state-initialised')
  }, 100)
})

class SiteSetup {
  constructor () {
    this.windowWidth = null
    // allow getInitFunction to be retrievable within callback functions 'this > that'
    this.getInitInstance = getInitInstance
    // bind contents trigger
    const contentsTrigger = document.querySelector('.contents-trigger')
    contentsTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      toggle(document.body, 'contents-visible', this.contentsToggleCallback, this)
    })
    // bind contents > project trigger
    document.querySelectorAll('#contents .projects .project').forEach((project) => {
      project.addEventListener('mouseenter', (e) => {
        document.querySelectorAll('#contents .projects .project.hover-current').forEach((current) => {
          current.classList.remove('hover-current')
        })
        project.classList.add('hover-current')
      })
    })

    // setup parallax, items are established with a data-parallax='0.2'
    document.querySelectorAll('[data-parallax]').forEach((p) => {
      parallax(p, {
        factor: p.getAttribute('data-parallax'),
        mobileFactor: p.getAttribute('data-mobile-parallax')
      })
    })
    // setup relativeScroll, items are established with a data--relative-scroll
    document.querySelectorAll('[data-relative-scroll]').forEach((rs) => {
      relativeScroll(rs, {
        factor: rs.getAttribute('data-relative-scroll'),
        triggerPoint: 0.2,
        isDecimal: true,
        property: 'opacity'
      })
    })
    // setup fixed headers on scroll
    const fixHeader = document.querySelector('#header.fixeable')
    if (fixHeader) {
      scrollPointTrigger(fixHeader, {
        allowMobile: true
      })
    }
    // bind contents paginate items
    document.querySelectorAll('#contents .paginator a').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault()
        this.paginate(document.querySelector('#contents .paginator'), a)
      })
    })

    // bind all lazy images
    document.querySelectorAll('.lazyload').forEach((el) => {
      fakeLazyLoad(el)
    })
    addHandler({
      resize: (w, h) => {
        this.windowWidth = w
        // reset all fixed widths
        this.calculateSiteWidth(w)
      },
      scroll: (top, left) => {}
    }, true)
  }
  /**
  * paginate items eg. 01 02 03 in contents, assumes it's followed by
  * multiple .page items,
  *
  * @param {htmlElement}, .paginator
  * @param {htmlElement}, .paginator > a
  */
  paginate (paginator, selectedTrigger) {
    // strip out the current states (trigger + page)
    paginator.querySelector('a.current-page').classList.remove('current-page')
    paginator.parentElement.querySelector('.page.current-page').classList.remove('current-page')

    // add classes to the new (trigger + page)
    const selectedIndex = selectedTrigger.getAttribute('data-page')
    const selectedPage = paginator.parentElement.querySelector(`.page[data-page="${selectedIndex}"]`)
    selectedTrigger.classList.add('current-page')
    selectedPage.classList.add('current-page')
  }
  /**
  * with opening/closing scrollbars, content jumps around all over the show,
  * to prevent this, lock of the body width at it's 'closed state', and keep it,
  * NOTE this is also exported below, so we can use it after other actions
  * TODO a lot of read/write going on in here. Might make transitions sluuuuuggggish
  *
  * @param {int} w window width
  */
  calculateSiteWidth (w) {
    document.body.classList.add('widths-initialised')

    const fixedEls = document.body.querySelectorAll('#header, #footer, .contents-trigger, #grid')
    const rightFixedEls = document.body.querySelectorAll('.contents-trigger')
    const rotatedEls = document.body.querySelectorAll('.close')
    let rotatedDimention
    if (rotatedEls) {
      rotatedDimention = `${Math.max(18, rotatedEls[0].clientWidth)}px`
    }

    // rotated els need px set sizes (css sets ems, according to variable font size)
    rotatedEls.forEach((el) => {
      el.style.width = null
      el.style.height = null
      el.style.width = rotatedDimention
      el.style.height = rotatedDimention
    })

    if (w > PHONE_MAX && !window.Modernizr.touchevents) {
      // if (!document.body.classList.contains('contents-visible') &&
      //     !document.body.classList.contains('index-visible')) {
      // clear width
      document.body.style.width = null
      // reset
      const bodyWidth = document.body.clientWidth
      document.body.style.width = `${bodyWidth}px`

      // fixed items within the standard content flow NEED to be recalculated :(
      // if we don't they jump around
      fixedEls.forEach((el) => {
        el.style.width = null
        el.style.width = `${el.clientWidth}px`
      })
      // fixed items that align to the right, need to be switched to left
      rightFixedEls.forEach((el) => {
        el.style.left = null
        el.style.right = 'auto'
        el.style.left = `${bodyWidth - el.clientWidth}px`
      })
      // }
    } else {
      // strip out all widths
      document.body.style.width = null
      fixedEls.forEach((el) => {
        el.style.width = null
        el.style.left = null
        el.style.right = null
      })
    }
  }
  /**
  * ...
  *
  * @param {bool} open, returns true if opening, false if closing
  * @param {Class} that, this(InitPage)
  */
  contentsToggleCallback (open, that) {
    if (!open) {
      // closeing
      if (!document.body.classList.contains('widths-initialised')) {
        that.calculateSiteWidth(that.windowWidth)
      }
    } else {
      // opening
      // phone - track current scroll for projects
      if (that.windowWidth < PHONE_MAX) {
        that.trackCurrentProjectScroll(document.querySelectorAll('#contents .projects .project'))
      }
      // get project-content initPage
      // if we're on that page, call pauseCurrentVideo
      let projectContentInit = that.getInitInstance(document.querySelector('#content .project-content'))
      if (projectContentInit) {
        projectContentInit.pauseCurrentVideo()
      }
    }
  }
  /**
  * whenthe contents are open and you scroll - update the 'current project',
  * NOTE we're not scrolling the body here, I've createed a bit of a 'handler'
  *      in here, just so It's a bit lighter on scroll calculations, but it
  *      disregards request animation frames
  * @param {htmlElement} project
  * @param {decimal} point - % of height
  *
  */
  trackCurrentProjectScroll (projects, point = 0.2) {
    const contents = document.getElementById('contents')
    if (contents.classList.contains('track-scroll-initialised')) {
      return
    }
    contents.classList.add('track-scroll-initialised')
    let handlers = []

    function addContentsHandler (handler, trigger) {
      handlers.push(handler)
    }

    function handleContentsResize () {
      var wsize = windowSize()
      for (var i = 0, l = handlers.length; i < l; i++) {
        if (handlers[i].resize) handlers[i].resize(wsize.width, wsize.height)
      }
    }

    function handleContentsScroll () {
      var wscroll = {
        left: (contents.scrollLeft) - (contents.clientLeft || 0),
        top: (contents.pageYOffset || contents.scrollTop) - (contents.clientTop || 0)
      }
      for (var i = 0, l = handlers.length; i < l; i++) {
        if (handlers[i].scroll) handlers[i].scroll(wscroll.top, wscroll.left)
      }
    }
    projects.forEach((project) => {
      let enable
      let projectStart
      let projectEnd
      let triggerPoint
      addContentsHandler({
        resize: (w, h) => {
          projectStart = getOffset(project).top - windowScroll().top
          projectEnd = projectStart + project.clientHeight + 1
          triggerPoint = h * point
          enable = w < PHONE_MAX
        },
        scroll: (top, left) => {
          if (enable) {
            if ((top + triggerPoint) > projectStart &&
                (top + triggerPoint) < projectEnd) {
              if (project.previousElementSibling) {
                // prevent duplicates
                project.previousElementSibling.classList.remove(`scroll-current`)
              }
              project.classList.add(`scroll-current`)
            } else {
              project.classList.remove(`scroll-current`)
            }
          }
        }
      }, true)
    })
    contents.addEventListener('resize', handleContentsResize)
    contents.addEventListener('scroll', handleContentsScroll)

    handleContentsResize()
    handleContentsScroll()
  }
}

class SiteInit {
  // initialises newly loaded content
  // recallable for ajax loaded content
  constructor () {
    const current = document.querySelectorAll('#content > article')
    initContainers(current)
    updateLinkState(document.querySelectorAll('#header, #footer, #content'))
  }
}

export const calculateSiteWidth = SiteSetup.prototype.calculateSiteWidth



// WEBPACK FOOTER //
// ./assets/j/src/site.js